import { PureComponent } from "react";
import PropTypes from "prop-types";
import TwilioVideo from "twilio-video";
import { isEmpty, first } from "lodash";

class AppContainer extends PureComponent<
  {
    token?: string;
    pageId?: string;
    onRoomLeave?: () => void;
    onRoomJoin?: (sid: string) => void;
    render?: any;
    pageTitle?: string;
  },
  {
    videoRoom: any;
    isJoining: boolean;
    userName: string;
    roomName: string;
    errorMessage: string;
    videoAllowed: boolean;
  }
> {
  static propTypes = {
    render: PropTypes.func.isRequired,
  };
  state = {
    videoRoom: null,
    isJoining: false,
    userName: "",
    roomName: "",
    errorMessage: null,
    videoAllowed: true,
  };

  componentDidMount() {
    console.log(this.props);
    const { token, pageId } = this.props;

    this.joinRoom(token, pageId);
  }

  joinRoom = async (token: string, pageId: string) => {

    this.setState({ isJoining: true });

    try {
      const localAudioTrack = await TwilioVideo.createLocalAudioTrack();
      const videoRoom = await TwilioVideo.connect(token, {
        name: pageId,
        tracks: [localAudioTrack],
        insights: false,
      });

      videoRoom.on("disconnected", () => {
        this.stopVideoTrack();
        this.stopAudioTrack();
        this.stopScreenTrack();
        const { onRoomLeave } = this.props;
        onRoomLeave();
        this.setState({
          videoRoom: null,
        });
      });
      const { onRoomJoin } = this.props;
      onRoomJoin(videoRoom.sid);
      this.setState({ videoRoom });
    } catch (error: any) {
      this.stopVideoTrack();
      this.stopAudioTrack();
      this.setState({
        errorMessage: error.message,
      });
    }

    this.setState({ isJoining: false });
  };

  leaveRoom = async () => {
    const { videoRoom } = this.state;

    if (videoRoom) {
      videoRoom.disconnect();
    }
  };

  handleMuteChange = async (muted) => {
    const { videoRoom } = this.state;

    if (videoRoom) {
      videoRoom.localParticipant.audioTracks.forEach(function (publication) {
        if (muted) {
          publication.track.disable();
        } else {
          publication.track.enable();
        }
      });
    }
  };

  handleVideoChange = async (paused) => {
    const { videoRoom } = this.state;

    if (videoRoom) {
      if (videoRoom.localParticipant.videoTracks.size === 0) {
        const localVideoTrack = await TwilioVideo.createLocalVideoTrack();
        if (localVideoTrack) {
          videoRoom.localParticipant.publishTrack(localVideoTrack);
        }
      }
      this.setState({ videoAllowed: true });
      videoRoom.localParticipant.videoTracks.forEach(function (publication) {
        if (paused) {
          publication.track.disable();
        } else {
          publication.track.enable();
        }
      });
    }
  };

  stopTrack = (trackName) => {
    const track = this.state[trackName];
    if (track) {
      track.stop();
    }
  };

  stopScreenTrack = () => this.stopTrack("screenTrack");

  stopVideoTrack = () => this.stopTrack("localVideoTrack");

  stopAudioTrack = () => this.stopTrack("localAudioTrack");

  shareScreen = async () => {
    const { videoRoom } = this.state;
    let screenTrack = false;

    if (!screenTrack) {
      navigator.mediaDevices
        .getDisplayMedia({
          audio: false,
          video: {
            frameRate: 10,
            height: 1080,
            width: 1920,
          },
        })
        .then((stream) => {
          const track = stream.getTracks()[0];
          videoRoom.localParticipant
            .publishTrack(track, {
              name: "screen",
              priority: "low",
            })
            .then((trackPublication) => {
              console.log("shared");
            })
            .catch(console.log);
        })
        .catch((error) => {
          if (error.name !== "AbortError" && error.name !== "NotAllowedError") {
            console.log("error");
          }
        });
    } else {
      videoRoom.localParticipant.unpublishTrack(screenTrack);
      this.stopScreenTrack();
    }
  };

  hideErrorMessage = () => this.setState({ errorMessage: null });

  changeUserName = (userName) => this.setState({ userName });

  changeRoomName = (roomName) => this.setState({ roomName });

  render() {
    const { render, pageTitle, pageId, token } = this.props;
    const { videoRoom, isJoining, userName, roomName, errorMessage } =
      this.state;

    const screenTrack = true;

    return render({
      videoRoom,
      userName,
      roomName: pageTitle,
      isVideoSupported: TwilioVideo.isSupported,
      isScreenSharingSupported: Boolean(
        navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia
      ),
      isScreenSharingEnabled: Boolean(screenTrack),
      canJoin: !isEmpty(userName) && !isEmpty(roomName),
      isJoining,
      onJoin: this.joinRoom,
      onLeave: this.leaveRoom,
      handleMuteChange: this.handleMuteChange,
      handleVideoChange: this.handleVideoChange,
      onShare: this.shareScreen,
      onRoomNameChange: this.changeRoomName,
      onUserNameChange: this.changeUserName,
      errorMessage,
      onErrorMessageHide: this.hideErrorMessage,
    });
  }
}

export default AppContainer;
